__webpack_require__.p = "/WEB2/";